import React, { useState, useEffect } from 'react';
import './Home.css'; // We'll create this CSS file
import logo from '../logo.png';

// Static gallery data - using your minimized images (16 images)
const staticGalleryItems = [
  {
    id: 1,
    title: 'Happy Children at Play',
    image: { url: '/images/photo_2025-09-20_22-54-45.jpg' }
  },
  {
    id: 2,
    title: 'Learning Adventures',
    image: { url: '/images/photo_2025-09-20_22-54-49.jpg' }
  },
  {
    id: 3,
    title: 'Fun Learning Moments',
    image: { url: '/images/photo_2025-09-20_22-55-00.jpg' }
  },
  {
    id: 4,
    title: 'Group Play Time',
    image: { url: '/images/photo_2025-09-20_22-55-03.jpg' }
  },
  {
    id: 5,
    title: 'Educational Activities',
    image: { url: '/images/photo_2025-09-20_22-55-06.jpg' }
  },
  {
    id: 6,
    title: 'Children Learning',
    image: { url: '/images/photo_2025-09-20_22-55-09.jpg' }
  },
  {
    id: 7,
    title: 'Happy Moments',
    image: { url: '/images/photo_2025-09-20_22-55-19.jpg' }
  },
  {
    id: 8,
    title: 'Learning Together',
    image: { url: '/images/photo_2025-10-28_22-43-57.jpg' }
  },
  {
    id: 9,
    title: 'School Activities',
    image: { url: '/images/photo_2025-10-28_22-44-20.jpg' }
  },
  {
    id: 10,
    title: 'Recent School Moments',
    image: { url: '/images/photo_2025-12-15_21-56-50.jpg' }
  },
  {
    id: 11,
    title: 'Children at Play',
    image: { url: '/images/photo_2025-12-15_21-57-02.jpg' }
  },
  {
    id: 12,
    title: 'Learning Environment',
    image: { url: '/images/photo_2025-12-15_21-57-16.jpg' }
  },
  {
    id: 13,
    title: 'Educational Fun',
    image: { url: '/images/photo_2025-12-15_21-57-23.jpg' }
  },
  {
    id: 14,
    title: 'School Activities',
    image: { url: '/images/photo_2025-12-15_21-57-29.jpg' }
  },
  {
    id: 15,
    title: 'Happy Learning',
    image: { url: '/images/photo_2025-12-15_21-57-35.jpg' }
  },
  {
    id: 16,
    title: 'Children Learning',
    image: { url: '/images/photo_2025-12-15_21-57-59.jpg' }
  }
];

function Home() {
  const [galleryItems] = useState(staticGalleryItems);
  const [currentSlide, setCurrentSlide] = useState(0);

  const uniqueGalleryItems = galleryItems.filter((item, index, self) =>
    self.findIndex(i => i.image?.url === item.image?.url) === index
  );

  useEffect(() => {
    if (uniqueGalleryItems.length > 1) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % uniqueGalleryItems.length);
      }, 4000); // Change slide every 4 seconds
      return () => clearInterval(interval);
    }
  }, [uniqueGalleryItems.length]);

  useEffect(() => {
    setCurrentSlide(0); // Reset to first slide when items change
  }, [uniqueGalleryItems.length]);

  const scrollToAbout = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % uniqueGalleryItems.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + uniqueGalleryItems.length) % uniqueGalleryItems.length);
  };

  return (
    <div id="home" className="home-container">
      <div className="hero-section">
        <h1><img src={logo} alt="Bubbles Early Years School" className="hero-logo" /> Bubbles Early Years School <img src={logo} alt="Bubbles Early Years School" className="hero-logo" /></h1>
        <p>Play â€¢ Learn â€¢ Grow</p>
        <p className="hero-subtitle"><span className="big-emoji">ðŸ“¢</span> Now Open for Registration!<br /><span className="age-text">For children ages 1-6 years</span></p>
        <div className="hero-buttons">
          <button className="btn primary-btn" onClick={scrollToAbout}>Learn More</button>
          <button className="btn secondary-btn" onClick={scrollToContact}>Enroll Now</button>
        </div>
      </div>

      <div className="features-section section">
        <h2>ðŸŽˆ What We Offer</h2>
        <div className="features-grid">
          <div className="feature-card">
            <h3>Creative Arts & Crafts</h3>
            <p>ðŸŽ¨ Painting, building, and hands-on projects</p>
          </div>
          <div className="feature-card">
            <h3>Storytelling & Literacy</h3>
            <p>ðŸ“– Building a love for books and words</p>
          </div>
          <div className="feature-card">
            <h3>Math & Logic Play</h3>
            <p>ðŸ”¢ Fun games with numbers, shapes, and puzzles</p>
          </div>
          <div className="feature-card">
            <h3>Music & Movement</h3>
            <p>ðŸŽ¶ Rhythm, dance, and self-expression</p>
          </div>
          <div className="feature-card">
            <h3>Science Explorations</h3>
            <p>ðŸ§ª Simple experiments and discovery play</p>
          </div>
          <div className="feature-card">
            <h3>Physical Play</h3>
            <p>ðŸ¤¸ Outdoor fun and gross motor skills</p>
          </div>
          <div className="feature-card">
            <h3>Imaginative Role Play</h3>
            <p>ðŸŽ­ Acting, pretending, and social learning</p>
          </div>
          <div className="feature-card">
            <h3>Free Play Corners</h3>
            <p>ðŸ§© Blocks, sensory play, and exploration spaces</p>
          </div>
        </div>
      </div>

      <div className="why-choose-section section">
        <h2>ðŸ’¡ Why Choose Bubbles?</h2>
        <div className="why-choose-content">
          <div className="why-choose-text">
            <p className="why-choose-intro">
              At Bubbles Early Years School, we believe childhood should be filled with curiosity, creativity, and joy.
              Our play-based learning approach combines fun with meaningful learning, making every day an adventure.
            </p>
            <p className="curriculum-text">
              We use a Blended International Curriculum designed to help children:
            </p>
            <ul className="curriculum-list">
              <li>âœ”ï¸ Develop early literacy & numeracy skills</li>
              <li>âœ”ï¸ Build creativity and imagination</li>
              <li>âœ”ï¸ Grow socially and emotionally</li>
              <li>âœ”ï¸ Gain confidence & independence</li>
              <li>âœ”ï¸ Explore the world through play and discovery</li>
            </ul>
          </div>
          <div className="animal-animation">
            ðŸ¯
          </div>
        </div>
      </div>

      <div className="gallery-section section">
        <h2>Adventures at Bubbles</h2>
        <p>Check out some of our happy moments!</p>
        {uniqueGalleryItems.length > 0 ? (
          <div className="slideshow-container">
            <button className="slide-arrow prev-arrow" onClick={prevSlide} disabled={uniqueGalleryItems.length <= 1}>
              â€¹
            </button>
            <div className="slide-image">
              {uniqueGalleryItems[currentSlide].image ? (
                <img
                  src={uniqueGalleryItems[currentSlide].image.url}
                  alt={uniqueGalleryItems[currentSlide].title}
                  style={{ width: '100%', height: '400px', objectFit: 'cover', borderRadius: '10px' }}
                />
              ) : (
                <div style={{ width: '100%', height: '400px', backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '10px' }}>
                  No Image
                </div>
              )}
            </div>
            <button className="slide-arrow next-arrow" onClick={nextSlide} disabled={uniqueGalleryItems.length <= 1}>
              â€º
            </button>
            <div className="slide-indicators">
              {uniqueGalleryItems.map((_, index) => (
                <span
                  key={index}
                  className={`indicator ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => setCurrentSlide(index)}
                ></span>
              ))}
            </div>
          </div>
        ) : (
          <div className="slide-image">
            <div style={{ width: '100%', height: '400px', backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '10px' }}>
              No Images Available
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Home;